import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setActionCounter,
  setAgencyCaseManagers,
  setBillingCodes,
  setCaregivers,
  setCaseManagers,
  setClinicians,
  setFacilities
} from 'src/store/modules/common'

import {
  ACTION_HUB_GET_COUNTER,
  ACTION_HUB_MODAL_ASSIGNEE_LIST_GET,
  ACTION_HUB_PATCH_ATTACHMENTS,
  COMMON_GET_AGENCY_CASE_MANAGERS,
  COMMON_GET_BILLING_PROGRAMS,
  COMMON_GET_CAREGIVERS,
  COMMON_GET_CASE_MANAGERS,
  COMMON_GET_CLINICIANS,
  COMMON_GET_FACILITIES,
  COMMON_SOURCE_GET_LIST,
  GOALS_LIST_GET,
  INTERVENTIONS_LIST_GET,
  REFERRAL_PAYERS_LIST_GET
} from 'src/utils/constants'

export const fetchBillingPrograms = () => async (dispatch: any) => {
  try {
    const codes = await httpClient.request({
      method: 'get',
      url: {
        pathname: COMMON_GET_BILLING_PROGRAMS
      }
    })

    dispatch(setBillingCodes(codes))
  } catch (error: any) {
    catchError(error)
  }
}

export const fetchFacilities =
  (config: any = {}) =>
  async (dispatch: any) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [] } = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMMON_GET_FACILITIES,
          params,
          query
        }
      })

      dispatch(setFacilities(items))
    } catch (err) {
      catchError(err)
    }
  }

export const fetchCaseManagers =
  (config: any = {}) =>
  async (dispatch: any) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [] } = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMMON_GET_CASE_MANAGERS,
          params,
          query
        }
      })

      dispatch(setCaseManagers(items))
    } catch (err) {
      catchError(err)
    }
  }

export const fetchClinicians =
  (config: any = {}) =>
  async (dispatch: any) => {
    const { params = {}, query = {} } = config

    try {
      const { items } = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMMON_GET_CLINICIANS,
          params,
          query
        }
      })

      dispatch(setClinicians(items))
    } catch (err) {
      catchError(err)
    }
  }

export const fetchCaregivers =
  (config: any = {}) =>
  async (dispatch: any) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [] } = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMMON_GET_CAREGIVERS,
          params,
          query
        }
      })

      dispatch(setCaregivers(items))
    } catch (err) {
      catchError(err)
    }
  }

export const getCommonAgencyCaseManagers =
  (config: any = {}) =>
  async () => {
    const { query = {} } = config

    try {
      const { items = [] } = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMMON_GET_AGENCY_CASE_MANAGERS,
          query
        }
      })

      return items
    } catch (err) {
      catchError(err)

      return []
    }
  }

export const fetchCommonAgencyCaseManagers =
  (config: any = {}) =>
  async (dispatch: any) => {
    const { query = {} } = config

    try {
      const { items = [] } = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMMON_GET_AGENCY_CASE_MANAGERS,
          query
        }
      })

      dispatch(setAgencyCaseManagers(items))
    } catch (err) {
      catchError(err)
    }
  }

export const getReferralSourceList = async (config: any = {}) => {
  try {
    const response = await httpClient.request({
      method: 'get',
      url: {
        pathname: COMMON_SOURCE_GET_LIST,
        ...config
      }
    })

    return response
  } catch (err) {
    catchError(err)

    return {}
  }
}

export const getGoals = async (config: any) => {
  const { params = {}, query = {} } = config

  try {
    const { items = [] } = await httpClient.request({
      method: 'get',
      url: {
        pathname: GOALS_LIST_GET,
        params,
        query
      }
    })

    return items
  } catch (error: any) {
    catchError(error)

    return []
  }
}

export const getInterventions = async (config: any) => {
  const { params = {}, query = {} } = config

  try {
    const items = await httpClient.request({
      method: 'get',
      url: {
        pathname: INTERVENTIONS_LIST_GET,
        params,
        query
      }
    })

    return items
  } catch (error: any) {
    catchError(error)

    return []
  }
}

export const getReferralPayers = async (config: any) => {
  const { params = {}, query = {} } = config

  try {
    const { items = [] } = await httpClient.request({
      method: 'get',
      url: {
        pathname: REFERRAL_PAYERS_LIST_GET,
        params,
        query
      }
    })

    return items
  } catch (error: any) {
    catchError(error)

    return []
  }
}

export const fetchActionCounter = () => async (dispatch: any) => {
  try {
    const count = await httpClient.request({
      method: 'get',
      url: {
        pathname: ACTION_HUB_GET_COUNTER
      }
    })

    dispatch(setActionCounter(count))
  } catch (err) {
    catchError(err)
  }
}

export const updateActionAttachment = async (config: any = {}) => {
  const { params = {}, payload = {} } = config

  try {
    const editableTask = await httpClient.request({
      method: 'patch',
      url: {
        pathname: ACTION_HUB_PATCH_ATTACHMENTS,
        params
      },
      payload
    })

    return editableTask
  } catch (err) {
    catchError(err)

    return false
  }
}

export const getAssigneeListActionModal = async (config: any = {}) => {
  const { query = {} } = config

  try {
    const items = await httpClient.request({
      method: 'get',
      url: {
        pathname: ACTION_HUB_MODAL_ASSIGNEE_LIST_GET,
        query
      }
    })

    return items
  } catch (err) {
    catchError(err)

    return []
  }
}
